import { motion } from "framer-motion";
import { SignupForm } from "./SignupForm";

const ease = [0.22, 1, 0.36, 1];

const Line = ({ children, delay, highlight }) => (
  <span className="block overflow-hidden pb-[0.1em]">
    <motion.span
      className={highlight ? "inline-block -rotate-1 bg-[var(--mauve)] px-4 italic text-white" : "block"}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease }}
    >
      {children}
    </motion.span>
  </span>
);

export const BossHero = () => (
  <section className="relative overflow-hidden bg-[var(--brown)] px-5 pb-24 pt-12 text-center text-white sm:px-8 lg:pb-32" data-testid="section-hero">
    <div className="mx-auto max-w-5xl">
      <motion.p
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease }}
        className="font-poster whitespace-nowrap text-[13vw] leading-none tracking-tight sm:text-[10vw] lg:text-[8rem]"
        data-testid="brand-logo"
      >
        ITS ME HARLEEEY
      </motion.p>
      <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1, delay: 0.2, ease }} className="mx-auto mt-8 h-40 w-40 rounded-full border-[5px] border-[var(--blush)] bg-[var(--cream)] overflow-hidden sm:h-48 sm:w-48">
        <img src="/photos/headshot-v2.jpg" alt="Harley smiling while leaning on a porch railing, wearing a brown t-shirt and gold necklace" className="h-full w-full rounded-full object-cover" fetchPriority="high" data-testid="hero-photo" />
      </motion.div>
      <p className="mt-8 text-xs font-semibold uppercase tracking-[0.3em] text-[var(--orange)]" data-testid="hero-tagline">Your phone. Your strategy. Your next move.</p>
      <h1 className="font-display mt-5 text-[2.1rem] font-light leading-[1.1] tracking-tight sm:text-5xl lg:text-6xl" data-testid="hero-headline">
        <Line delay={0.25}>I didn't start to get rich.</Line>
        <Line delay={0.4} highlight>I started because my card declined.</Line>
      </h1>
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.7, ease }}
        className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed sm:text-xl"
        data-testid="hero-subheadline"
      >
        Let Me Show You 30+ Ways to Start Earning Online. Some <em className="font-semibold not-italic underline decoration-[var(--blush)] decoration-2 underline-offset-4">WITHOUT</em> Going Live, Selling, or Showing Your Face.
      </motion.p>
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.9, ease }} className="mt-12">
        <SignupForm />
      </motion.div>
    </div>
  </section>
);
